<template>
  <Content id="drProject">
    <div slot="search">
      <Form :label-width="45" :model="search" id="searchForm">
        <Row>
          <Col><FormItem label="条形码" :label-width="60"><el-input v-model="search.barCode" :maxlength="13" :clearable="true" @input="toInt()"/></FormItem>
          </Col>
          <!--
          <Col>
            <FormItem label="体检任务" :label-width="80">
              <el-select v-model.trim="search.taskId" placeholder="体检任务"
                         filterable size="small" transfer="true" :popper-append-to-body="false" style="min-width: 350px;">
                <el-option v-for="item in taskList" :key="item.value" :label="item.label" :value="item.value"
                           @click.native="handleTaskChange(item)" style="min-width: 350px;"/>
              </el-select>
            </FormItem>
          </Col>
          -->
          <Col>
            <FormItem  label="学校"  prop="schoolId">
              <el-select v-model.trim="search.schoolId" placeholder="请选择学校"
                         clearable filterable size="small" transfer="true" :popper-append-to-body="false"
                         style="width: 100%;" @change="changeSchool">
                <el-option v-for="item in schoolsList" :key="item.value" :label="item.label" :value="item.value"
                           @click.native="handleShoolChange(item)" style="width: 100%;"/>
              </el-select>
            </FormItem>
          </Col>
          <Col>
            <FormItem  label="年级"  prop="gradeId">
              <el-select v-model.trim="search.gradeId" placeholder="请选择年级"
                         clearable filterable size="small" transfer="true" :popper-append-to-body="false"
                         style="width: 100%;" @change="changeGrade">
                <el-option v-for="item in gradeList" :key="item.id" :label="item.name" :value="item.id"
                           @click.native="handleGradeChange(item)" style="width: 100%;"/>
              </el-select>
            </FormItem>
          </Col>
          <Col>
            <FormItem  label="班级"  prop="classesId">
              <el-select v-model.trim="search.classesId" placeholder="请选择班级"
                         clearable filterable size="small" transfer="true" style="width: 100%;"
                         :popper-append-to-body="false">
                <el-option v-for="item in classesList" :key="item.id" :label="item.name" :value="item.id"
                           @click.native="handleClassChange(item)" style="width: 100%;"/>
              </el-select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="图片">
              <Select v-model="search.imageStatus" :clearable="true">
                <Option v-for="item in imageStatus" :value="item.value" v-bind:key="item.value">{{item.label}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="结果">
              <Select v-model="search.resultStatus" :clearable="true">
                <Option v-for="item in resultStatus" :value="item.value" v-bind:key="item.value">{{item.label}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="日期">
              <DatePicker style="width:114px ;" type="date" :editable="false" placeholder="起始日期" format="yyyy-MM-dd"
                          v-model="search.startDate" @on-change="changestart"/>
              <DatePicker style="width:114px ;" type="date" :editable="false" placeholder="结束日期" format="yyyy-MM-dd"
                          v-model="search.endDate" @on-change="changeend"/>
            </FormItem>
          </Col>
          <Col>
            <div style="display:flex;">
              &nbsp;&nbsp;<Button type="primary" @click="query">查询</Button>
            </div>
          </Col>
        </Row>
      </Form>

      <div slot="extra" style="margin-bottom: 5px; display: flex;" >
        <Button size="small" style="margin-left: 5px;" icon="ios-share-outline" @click="importData" type="primary">导入</Button>
      </div>
    </div>


    <el-table :data="dataList" style="width: 100%;" :header-cell-style="{ background:'#f8f8f9',color:'#515a6e','text-align':'center'}"
              :row-class-name="tableRowClassName" @row-click="selectrow" @selection-change="selectList" tooltip-effect="dark"
              highlight-current-row highlight-selection-row row-key="id" :max-height="tableHeight">

      <el-table-column fixed="left" align="center" prop="name" label="姓名" min-width="80"/>
      <el-table-column align="center" prop="birthday" label="出生日期" min-width="110"/>
      <el-table-column align="center" prop="schoolName" label="学校" show-overflow-tooltip  min-width="200"/>
      <el-table-column align="center" prop="gradeName" label="年级" show-overflow-tooltip  min-width="150"/>
      <el-table-column align="center" prop="classesName" label="班级" show-overflow-tooltip  min-width="150"/>
      <el-table-column align="center" prop="imageStatus" label="图片状态" min-width="110">
        <template slot-scope="{row}">
          <el-tag size="small" :type="row.imageStatus===2?'success':'danger'" disable-transitions v-if="row.imageStatus">
            {{  imageStatus.filter(u => u.value === row.imageStatus)[0].label }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="resultStatus" label="状态" min-width="110">
        <template slot-scope="{row}">
          <el-tag size="small" :type="row.resultStatus === 2 ? 'success' : 'danger'" disable-transitions v-if="row.resultStatus">
            {{  resultStatus.filter(u => u.value === row.resultStatus)[0].label }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="createTime" label="创建时间" min-width="180"/>
      <el-table-column align="center" prop="operator" label="最后操作人" min-width="100"/>
      <el-table-column align="center" prop="updateTime" label="更新时间" min-width="160"/>
      <el-table-column fixed="right" align="center" prop="operation" label="操作"  min-width="80">
        <template slot-scope="{row}">
          <el-button type="text" size="small" @click="detail(row)" :disabled="!(row.imageStatus===2&&row.resultStatus===2)">报告详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <Page :total="pageList.total" :current="pageList.currentPage" :page-size="pageList.pageSize"
          show-elevator show-sizer show-total @on-change="chagecurrent"
          :page-size-opts="[10, 30, 50, 100]"
          @on-page-size-change="chagepagesize" style="margin-top:10px;"/>

    <el-dialog title="导入DR" :visible.sync="importWindow" width="400px" custom-class="my-dialog"
               :destroy-on-close="true" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-upload action="#" :limit="1" class="upload-demo" drag multiple :auto-upload="false"
                 :on-change="handleChange" :on-remove="handleRemove"
                 :file-list="fileList">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
<!--        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>-->
      </el-upload>
      <div><a @click.stop="template()">文件模版</a></div>

      <span slot="footer" class="dialog-footer">
        <el-button  @click="handleCancle">取 消</el-button>
        <el-button type="primary" @click="handleUpload">确 定</el-button>
      </span>
    </el-dialog>

    <Modal v-model="reportWindow" width="50%" :styles="{'top':'60px'}" :mask-closable="false" :footerHide="true" :scrollable="true" :showHead="false">
      <slot name="header"><div style="line-height: 24px;font-size: 18px;color: #303133;">{{ windowTitle }}</div></slot>
      <drReport ref="detail" :physicalId="reportData.physicalId" :barCode="reportData.barCode" :reportCode="reportData.reportCode"
                width="" :style="{'max-height':modalHeight ,'overflow-y': 'auto'}"/>
    </Modal>

  </Content>
</template>
<script>
import {_page, _upload, _template} from "@/services/screening/drProject.js";
import {_gradesList, _classesList} from "@/services/studentManage/studentManage";
import {enums} from "@/services/enums";
import {mixins} from "@/mixins";
import drReport from "@/views/printReport/drReport/drReport.vue";
export default {
  name: "DrProject",
  mixins: [mixins],
  components: {drReport},
  computed: {
    modalHeight() {
      // 根据屏幕宽度分段设置高度（示例值可调整）
      if (this.windowWidth <= 768) { // 移动端
        return `${this.windowHeight * 0.8}px`;
      } else if (this.windowWidth <= 1366) { // 小屏PC
        return '600px';
      } else { // 大屏
        return '700px';
      }
    }
  },
  data() {
    return {
      tableHeight: 0,
      currentRowIndex: null,
      search: {
        barCode:"",
        taskId:"",
        schoolId:"",
        gradeId:"",
        classesId:"",
        imageStatus:"",
        resultStatus:"",
        startDate:"",
        endDate:""
      },
      reportData:{
        barCode:"",
        physicalId:"",
        reportCode:"",
      },
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      fileList:[],
      importWindow:false,
      reportWindow:false,
      windowTitle:"报告详情",
      enums:enums,
      gradeList:[],
      classesList:[],
      dataList: [],
      pageList: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      imageStatus:[
        {label: '全部', value: ''},
        {label: '待导入', value: 1},
        {label: '已导入', value: 2}
      ],
      resultStatus:[
        {label: '全部', value: ''},
        {label: '待导入', value: 1},
        {label: '已导入', value: 2}
      ],
    };
  },
  created(){
    this.setDynamicHeight();
    window.addEventListener('resize', this.setDynamicHeight);
  },
  mounted() {
    if (this.$userSession.checkInstitutionId()) {
      if (this.search.taskId || this.search.schoolId) {
        this.handleDataList();
      }
      this.applySchoolsList();
    }
  },
  methods: {
    setDynamicHeight() {
      const height = window.innerHeight || document.documentElement.clientHeight;
      this.tableHeight = `${height - 300}px`;
    },
    changeSchool(schoolId){
      if(!schoolId){
        return;
      }
      _gradesList({schoolId : schoolId}).then(res=>{
        this.search.schoolId = schoolId;
        this.search.gradeId = "";
        if (res.errcode === 1 && res.data){
          this.gradeList = res.data;
        }else{
          this.gradeList =[]
        }
      })
    },
    changeGrade(gradeId){
      if(!gradeId){
        return;
      }
      _classesList({schoolId:this.search.schoolId, gradeId : gradeId}).then(res=>{
        this.search.gradeId = gradeId;
        this.search.classesId = "";
        if (res.errcode === 1 && res.data){
          this.classesList = res.data;
        }else{
          this.classesList =[]
        }
      })
    },
    handleTaskChange(item) {
      this.search.taskId = item.id;
      this.search.taskName = item.name;
    },
    handleShoolChange(item) {
      this.search.schoolId = item.id;
      this.search.schoolName = item.name;
    },
    handleGradeChange(item) {
      this.search.gradeId = item.id;
      this.search.gradeName = item.name;
    },
    handleClassChange(item) {
      this.search.classesId = item.id;
      this.search.className = item.name;
    },
    template(){
      _template().then(res => {}).catch(error => {});
    },
    importData(){
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }
      this.fileList = [];
      this.importWindow = true;
    },
    handleChange(file, fileList){
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return
      }
      this.fileList = fileList;
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    handleCancle() {
      this.fileList = [];
      this.importWindow = false;
    },
    handleUpload(){
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return
      }else if(this.fileList && this.fileList.length === 0){
        return;
      }

      _upload({file: this.fileList[0].raw}).then(res=>{
        this.fileList = [];
        if (res && res.errcode && res.errcode === 1){
          this.importWindow = false;
          this.$message.success("上传成功");
          this.handleDataList()
          // this.reload()
        } else{
          this.$message({
            type: 'error',
            message: res.errmsg,
            duration: 30000,
            center: true
          });
        }
      }).catch(() => {});
    },
    query() {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }else if (!this.search.schoolId) {
        this.$message.warning('请先选择学校');
        return;
      }

      this.pageList.currentPage = 1;
      this.handleDataList();
    },
    handleDataList() {

      _page({
        ...this.search,
        ...this.pageList,
      }).then(res => {
        this.dataList = res.data.records;
        this.pageList.total = res.data.total;
      }).catch(() => {});
    },
    detail(row) {
      this.reportData.reportCode = "";
      this.reportWindow = false;
      if(row.imageStatus === 1 && row.resultStatus === 1){
        return;
      }
      this.windowTitle = "报告详情";
      this.reportData.barCode = row.barCode;
      this.reportData.physicalId = row.physicalId;
      this.reportData.reportCode = "drReport";
      this.reportWindow = true;
    },
    tableRowClassName(row, rowIndex) {
      row.row.index = row.rowIndex;
      if (this.currentRowIndex === row.rowIndex) {
        return "select-row";
      }else{
        return "";
      }
    },
    selectList(e){

    },
    selectrow(e, index, event){
      this.currentRowIndex = e.index;
    },
    chagecurrent(e) {
      this.pageList.currentPage = e
      this.handleDataList()
    },
    chagepagesize(e) {
      this.pageList.pageSize = e
      this.handleDataList()
    },
    changestart(e) {
      this.search.startDate = e
    },
    changeend(e) {
      this.search.endDate = e
    },
    toInt(){
      if(this.search.barCode){
        this.search.barCode = (this.search.barCode + "").replace(/[^\d]+/g, '');
        this.search.barCode = (this.search.barCode + "").replace('.', '');
        this.search.barCode = (this.search.barCode + "").replace(/\./g, '');
        this.search.barCode = (this.search.barCode + "").replace(/\\./g, '');
        this.search.barCode = (this.search.barCode + "").replace('$#$', '');
      }
    }
  }
};
</script>
<style lang="postcss" scoped>
/deep/ #searchForm .ivu-form-item {margin-bottom: 5px;vertical-align: top;zoom: 1;}
/deep/ .el-dialog__body {padding: 5px 20px;}
/deep/ .el-input__inner {height: 32px;line-height: 32px;}
/deep/ .el-input__icon{line-height: 32px;}
/deep/ .el-input--suffix .el-input__inner {padding-right: 0px;}

</style>
